export const iconFontAwesomeHandsHandsBound = (
	<i className="fa-solid fa-hands-bound"></i>
);
